import { combineReducers } from "redux";

import MangeUserProfileReducer from "./MangeUserProfileReducer";
import MangeExpiredDate from "./MangeExpiredDate";

export default combineReducers({

    selectedProfile : MangeUserProfileReducer ,
    expiredDate : MangeExpiredDate 
    
   

   
});
